<template>
  <v-container fluid>
    <PageHeading
      :text="'Страницы помощи'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-info-page-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать страницу помощи
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridInfoPages ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridInfoPages from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageInfoPages',
  components: {
    PageHeading,
    GridInfoPages
  },
  metaInfo () {
    return {
      title: 'Страницы помощи'
    }
  },
  mixins: [gridPageInterface]
}
</script>
